// PRD-527 Remember Email — device-local pre-fill of the sign-in email.
//
// Stores ONLY the email string, normalized (lowercased + trimmed). NEVER a
// password, OTP, JWT, session cookie, or token (R2). Reads are resilient: a
// malformed/unreadable value is treated as empty and cleared (R6).
//
// The enable/disable gate defaults to Enabled (PRD default). It is persisted
// device-locally for now; once the backend exposes the org-level "Remember
// Email" setting, `isRememberEmailEnabled` should read that instead (R4/R5).

const EMAIL_KEY = 'rhd_remembered_email';
const ENABLED_KEY = 'rhd_remember_email_enabled';

export function isRememberEmailEnabled() {
  try {
    const v = localStorage.getItem(ENABLED_KEY);
    return v === null ? true : v === 'true'; // default: Enabled
  } catch {
    return true;
  }
}

export function setRememberEmailEnabled(enabled) {
  try {
    localStorage.setItem(ENABLED_KEY, enabled ? 'true' : 'false');
    if (!enabled) clearRememberedEmail(); // R4: disabling clears any stored value
  } catch {
    /* storage unavailable — ignore */
  }
}

export function getRememberedEmail() {
  try {
    const v = localStorage.getItem(EMAIL_KEY);
    if (typeof v === 'string' && v.includes('@')) return v;
    if (v !== null) localStorage.removeItem(EMAIL_KEY); // R6: drop malformed value
    return '';
  } catch {
    return '';
  }
}

export function setRememberedEmail(email) {
  try {
    if (typeof email !== 'string') return;
    const normalized = email.trim().toLowerCase();
    if (normalized.includes('@')) localStorage.setItem(EMAIL_KEY, normalized);
  } catch {
    /* storage unavailable — ignore */
  }
}

export function clearRememberedEmail() {
  try {
    localStorage.removeItem(EMAIL_KEY);
  } catch {
    /* storage unavailable — ignore */
  }
}

// In-flight email — sessionStorage (per-tab, cleared when the tab closes) so a
// submitted email survives the SSO redirect / reload WITHOUT persisting across
// users on a shared browser. The persistent remember (localStorage) is written
// only on successful auth (App.js), per PRD R2.
const INFLIGHT_KEY = 'rhd_login_email_inflight';

export function getInflightEmail() {
  try {
    const v = sessionStorage.getItem(INFLIGHT_KEY);
    if (typeof v === 'string' && v.includes('@')) return v;
    if (v !== null) sessionStorage.removeItem(INFLIGHT_KEY);
    return '';
  } catch {
    return '';
  }
}

export function setInflightEmail(email) {
  try {
    if (typeof email !== 'string') return;
    const normalized = email.trim().toLowerCase();
    if (normalized.includes('@')) sessionStorage.setItem(INFLIGHT_KEY, normalized);
  } catch {
    /* storage unavailable — ignore */
  }
}

export function clearInflightEmail() {
  try {
    sessionStorage.removeItem(INFLIGHT_KEY);
  } catch {
    /* storage unavailable — ignore */
  }
}
